export interface BreadcrumbTrailEntry {
  label: string;
  href: string;
}

function isBreadcrumbTrailEntry(value: unknown): value is BreadcrumbTrailEntry {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const entry = value as Partial<BreadcrumbTrailEntry>;
  return (
    typeof entry.label === 'string' &&
    entry.label.trim().length > 0 &&
    typeof entry.href === 'string' &&
    entry.href.trim().length > 0
  );
}

export function normalizeBreadcrumbTrail(value: unknown): BreadcrumbTrailEntry[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .map((entry) => {
      if (isBreadcrumbTrailEntry(entry)) {
        return {
          label: entry.label.trim(),
          href: entry.href.trim(),
        };
      }

      if (typeof entry === 'string' && entry.trim().length > 0) {
        return {
          label: entry.trim(),
          href: '/explore',
        };
      }

      return null;
    })
    .filter((entry): entry is BreadcrumbTrailEntry => entry !== null);
}

export function breadcrumbPathname(href: string): string {
  if (href.startsWith('/')) {
    return href.split('?')[0]?.split('#')[0] ?? href;
  }
  try {
    return new URL(href).pathname;
  } catch {
    return href.split('?')[0]?.split('#')[0] ?? href;
  }
}

export function appendBreadcrumbStep(
  trail: BreadcrumbTrailEntry[],
  step: BreadcrumbTrailEntry
): BreadcrumbTrailEntry[] {
  const stepPath = breadcrumbPathname(step.href);
  const matchIndex = trail.findIndex((entry) => breadcrumbPathname(entry.href) === stepPath);
  if (matchIndex >= 0) {
    return [...trail.slice(0, matchIndex), step];
  }
  return [...trail, step];
}
